/*!
 *
 * Angle - Bootstrap Admin Template
 *
 * Version: 4.8
 * Author: @themicon_co
 * Website: http://themicon.co
 * License: https://wrapbootstrap.com/help/licenses
 *
 */

import { Component } from "react";
import { BrowserRouter } from "react-router-dom";

// App Routes
import Routes from "./Routes";

// Vendor dependencies

import "./modernizr.js";

// Application Styles
// import './styles/bootstrap.scss';
import "./styles/app.scss";

class App extends Component {
  render() {
    const basename = import.meta.env.DEV ? "/" : import.meta.env.BASE_URL || "/";

    return (
      <BrowserRouter basename={basename}>
        <Routes />
      </BrowserRouter>
    );
  }
}

export default App;
